import { Injectable } from "@angular/core";
import { BaseGridResponse } from "planning-portal-library/src/lib/data/shared/base-grid.response";
import { BaseRequest } from "planning-portal-library/src/lib/data/shared/base.request";
import { Observable } from "rxjs";

import { UseCase } from "../../base/use-case";
import { Job } from "../../domain/models/job";
import { GetJobsGridDataRequest } from "../../domain/requests/jobs/get-jobs.request";
import { JobsRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class GetJobsUsecase implements UseCase<BaseRequest<GetJobsGridDataRequest>, BaseGridResponse<Job>> {

  constructor(private jobRepository: JobsRepository) {
  }

  execute(params: BaseRequest<GetJobsGridDataRequest>): Observable<BaseGridResponse<Job>> {
    return this.jobRepository.getJobs(params);
  }

}
